import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import NRDynamicJiraFieldInput from './NRDynamicJiraFieldInput';

function NRDynamicJiraField({ field, control, disabled = false, error, rpcOptions }) {
  const theme = useTheme();

  if (!field?.key) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(140px, 0.9fr) auto minmax(180px, 1.3fr)',
        alignItems: 'center',
        gap: theme.spacing(2),
        px: theme.spacing(2),
        py: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
        backgroundColor: 'transparent'
      }}
    >
      <Typography variant="subtitle2" color="text.primary" component="label" htmlFor={`jira-dynamic-${field.key}`}>
        {field.name}
        {field.required ? ' *' : ''}
      </Typography>

      <ArrowForwardIcon
        aria-hidden
        sx={{
          fontSize: 18,
          color: theme.palette.text.secondary,
          flexShrink: 0
        }}
      />

      <Box minWidth={0}>
        <NRDynamicJiraFieldInput
          field={field}
          control={control}
          disabled={disabled}
          error={error}
          rpcOptions={rpcOptions}
        />
      </Box>
    </Box>
  );
}

export default NRDynamicJiraField;
